import { Title } from '#shared/components/UI';
import UsersProvider from './Users.provider';
import UsersList from './UsersList/UsersList';
import { UsersHostProps } from './types';

// The feature root: takes the host props and mounts the feature-local provider, so every internal
// component's useUsers() resolves. Hosts render it from the shared/users entry:
// <UsersPage {...useUsersHostProps()} />.
export default function UsersPage({
  title,
  viewer,
  account,
  userPermissions,
  createRoleInSubAccounts,
  updateRoleInSubAccounts,
  countSubAccounts,
  deleteRoleFromSubAccounts,
}: UsersHostProps) {
  return (
    <UsersProvider
      viewer={viewer}
      account={account}
      userPermissions={userPermissions}
      createRoleInSubAccounts={createRoleInSubAccounts}
      updateRoleInSubAccounts={updateRoleInSubAccounts}
      countSubAccounts={countSubAccounts}
      deleteRoleFromSubAccounts={deleteRoleFromSubAccounts}
    >
      <div>
        {title && <Title>{title}</Title>}
        <UsersList />
      </div>
    </UsersProvider>
  );
}
